import type { SVGProps } from 'react';
const SvgSociety = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10M1 6h10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M6 1a7.65 7.65 0 0 1 2 5 7.65 7.65 0 0 1-2 5 7.65 7.65 0 0 1-2-5 7.65 7.65 0 0 1 2-5"
    />
  </svg>
);
export default SvgSociety;
